export const BreadcrumbTextSelected =
  'text-[#EE3E5C] text-[15px] font-medium leading-[24px] not-italic';
export const BreadcrumbTextDefault =
  'text-[#3E5A6A] text-[15px] font-medium leading-[24px] not-italic';
